import { render, staticRenderFns } from "./auction-category-form.vue?vue&type=template&id=a6b4423a&"
import script from "./auction-category-form.vue?vue&type=script&lang=js&"
export * from "./auction-category-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports